// Shared constants and formatting helpers of the appointments module.

export const STATUSES = [
  'scheduled',
  'confirmed',
  'waiting',
  'in_progress',
  'completed',
  'missed',
  'cancelled',
];

export const STATUS_STYLE = {
  scheduled: { badge: 'bg-n-blue-3 text-n-blue-11', dot: 'bg-n-blue-9' },
  confirmed: { badge: 'bg-n-teal-3 text-n-teal-11', dot: 'bg-n-teal-9' },
  waiting: { badge: 'bg-n-amber-3 text-n-amber-11', dot: 'bg-n-amber-9' },
  in_progress: {
    badge: 'bg-n-iris-3 text-n-iris-11',
    dot: 'bg-n-iris-9',
  },
  completed: { badge: 'bg-n-slate-3 text-n-slate-11', dot: 'bg-n-slate-9' },
  missed: { badge: 'bg-n-ruby-3 text-n-ruby-11', dot: 'bg-n-ruby-9' },
  cancelled: { badge: 'bg-n-slate-2 text-n-slate-10', dot: 'bg-n-slate-7' },
};

export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export const WEBHOOK_EVENTS = [
  'appointment.created',
  'appointment.confirmed',
  'appointment.updated',
  'appointment.completed',
  'appointment.missed',
  'appointment.cancelled',
  'appointment.reminder',
];

const pad = n => String(n).padStart(2, '0');

// Local (browser) date as YYYY-MM-DD — never toISOString(), which shifts to UTC.
export const toDateInput = date =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
export const toTimeInput = date =>
  `${pad(date.getHours())}:${pad(date.getMinutes())}`;
export const fromInputs = (dateStr, timeStr) =>
  new Date(`${dateStr}T${timeStr || '00:00'}:00`);

export const sameDay = (a, b) => a.toDateString() === b.toDateString();
export const startOfWeek = date => {
  const copy = new Date(date);
  copy.setDate(copy.getDate() - copy.getDay());
  copy.setHours(0, 0, 0, 0);
  return copy;
};
export const addDays = (date, n) => {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + n);
  return copy;
};

export const localeTag = locale => (locale || 'en').replace('_', '-');

export const fmtTime = (iso, locale) =>
  new Date(iso).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
export const fmtDateTime = (iso, locale) =>
  new Date(iso).toLocaleString(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  });
// `undefined` cai no locale do navegador e imprime R$150.00 numa tela em pt-BR; o locale da
// interface é quem manda.
export const fmtMoney = (value, locale, currency = 'BRL') => {
  if (value === null || value === undefined || value === '') return '';
  return new Intl.NumberFormat(localeTag(locale), {
    style: 'currency',
    currency,
  }).format(Number(value));
};
